import { useAtomValue, useSetAtom } from 'jotai';
import { TouchEvent, useRef, useState } from 'react';

import {
  zoomLevelAtom,
  isLeftClickAtom,
  isRightClickAtom,
  isCtaModalOpenAtom,
} from '../store/index.atom';

import useUpdateViewerPageState from './useUpdateViewerPageState';

interface Props {
  totalPage?: number;
  isNextSwipeDisabled?: boolean;
  updateNextThumbnails?: (page: number) => void;
  updatePrevThumbnails?: (page: number) => void;
}

const useSwipe = ({
  totalPage,
  isNextSwipeDisabled,
  updateNextThumbnails,
  updatePrevThumbnails,
}: Props) => {
  const zoomLevel = useAtomValue(zoomLevelAtom);

  const { updateCurrentPage, currentPage } = useUpdateViewerPageState();

  const setIsLeftClick = useSetAtom(isLeftClickAtom);
  const setIsRightClick = useSetAtom(isRightClickAtom);

  const isCtaModalOpen = useAtomValue(isCtaModalOpenAtom);

  const touchStartRef = useRef(0);
  const [value, setValue] = useState<'prev' | 'next' | null>(null);

  const handleTouchStart = (event: TouchEvent<HTMLDivElement>) => {
    touchStartRef.current = event.touches[0].clientX;
  };

  const handleTouchMove = (event: TouchEvent<HTMLDivElement>) => {
    const touchEnd = event.touches[0].clientX;
    const touchDiff = touchEnd - touchStartRef.current;

    if (isCtaModalOpen) {
      return;
    }

    if (zoomLevel > 1) {
      return;
    }

    if (touchDiff > 10) {
      setValue('prev');
    } else if (touchDiff < -10) {
      setValue('next');
    }
  };

  const handleTouchEnd = () => {
    if (!value) {
      return;
    }
    if (isCtaModalOpen) {
      return;
    }

    if (value === 'next') {
      setValue(null);
      if (currentPage === totalPage || isNextSwipeDisabled) {
        return;
      }
      setIsRightClick(true);
      setTimeout(() => setIsRightClick(false), 500);
      updateCurrentPage(currentPage + 1);
      updateNextThumbnails?.(currentPage + 1);
    } else if (value === 'prev') {
      setValue(null);
      if (currentPage === 1) {
        return;
      }
      setIsLeftClick(true);
      setTimeout(() => setIsLeftClick(false), 500);
      updateCurrentPage(currentPage - 1);
      updatePrevThumbnails?.(currentPage - 1);
    }
  };

  return {
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
  };
};

export default useSwipe;
